import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import logo from "../../Logo.png";
import Apps from "./apps";
import { auth, functions } from "../../firebase";
import { useHistory } from "react-router-dom";
import NewApp from "./newapp";
import Account from "./account";
import { Route } from "react-router-dom";
const createApp = functions.httpsCallable("createApp");
const deleteApp = functions.httpsCallable("deleteApp");
export default function Home() {
  const history = useHistory();
  const [user, setUser] = useState(null);
  const handleLogout = () => {
    auth.signOut();
    history.push("/auth/login");
  };

  const handleNewApp = (appId) => {
    createApp({ appId: appId })
      .then((data) => {
        // history.push(`/${appId}/canvas/pages/index`);
      })
      .catch((err) => {
        alert("We had an error setting up this app");
      });
  };

  const handleDeleteApp = (appId) => {
    deleteApp({ appId })
      .then(() => {})
      .catch((err) => {
        alert("We had an error deleting");
      });
  };

  const toAccount = () => {
    history.push(`/home/account`);
  };

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      if (!u) {
        history.push("/auth/login");
      } else {
        setUser(u);
      }
    });
    return unsub;
  }, []);

  if (!user) {
    return null;
  }
  return (
    <div className={styles.home}>
      <div className={styles.headerContainer}>
        <div className={styles.header}>
          <img src={logo} alt="BREVITY LOGO" width={30} height={30} />
          <div className="logo-text">BREVITY</div>
          <div style={{ flexGrow: 1 }} />
          <button onClick={toAccount} className={styles.menu}>
            Account
          </button>
          <button onClick={handleLogout} className={styles.logout}>
            Logout
          </button>
        </div>
      </div>

      <div className={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className={styles.title}>Apps</div>

          <NewApp onSubmit={handleNewApp} />
        </div>
        <Apps onDelete={handleDeleteApp} user={user} />
      </div>
      <Route path={"/home/account"}>
        <Account user={user} onClose={() => history.push("/home")} />
      </Route>
    </div>
  );
}
